export enum FreshServicePriorityEnum {
    Na = 0,
    Low,
    Medium,
    High,
    Urgent,
}
